import SectionTitle from '@anm/components/video-landings/SectionTitle';
import { PLAYBAR_CONTROLS } from '@anm/data/hostingDefaults';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { Configs } from '@anm/hosting-player';
import React, { useCallback, FC } from 'react';
import { useDispatch } from 'react-redux';

import { hostedVideoActions } from '../../../store/modules/hostedVideo';
import { ChangeHandlers } from '../types';

import ControlsPanel, { ControlsList } from './ControlsPanel';
import { FormWrapper, SaveButton } from './Wrapper';

export type CurrentValue = {
  id: ControlsList;
  value: any;
};

export type CustomizationFormProps = ChangeHandlers & {
  isPosterSection?: boolean;
};

type CustomizationFormInnerProps = CustomizationFormProps & {
  configs: Configs;
};

const CustomizationForm: FC<CustomizationFormInnerProps> = ({ configs, wasChanged, getHandlers }) => {
  const dispatch = useDispatch();
  const { save, isPending } = getHandlers();

  const handleChange = useCallback(
    ({ id, value }: CurrentValue) => {
      const currentValue = { [id]: value };

      const isPlaybarControl = PLAYBAR_CONTROLS.some(c => c === id);

      const newConfigs: Configs = isPlaybarControl
        ? { ...configs, playbar: { ...configs.playbar, ...currentValue } }
        : { ...configs, ...currentValue };

      dispatch(
        hostedVideoActions.updateConfigs({
          ...newConfigs
        })
      );
    },
    [configs]
  );

  return (
    <FormWrapper>
      <SectionTitle level={2} title="Player settings" />
      <ControlsPanel {...{ handleChange }} initialConfigs={configs} />
      {isMobileOrIPad() && (
        <SaveButton
          onClick={save}
          variant="light-blue"
          size="long_static_width"
          disabled={!wasChanged}
          {...{ isPending }}
        >
          {wasChanged ? 'Save' : 'All Changes Saved '}
        </SaveButton>
      )}
    </FormWrapper>
  );
};

export default CustomizationForm;
